import { TextInput } from 'flowbite-react';
import React, { useMemo, useState } from 'react';
import Downshift from 'downshift';
import cx from 'classnames';
import { useQuery } from 'react-query';
import { searchCompanies } from 'src/apis/auth';

function CompanySelection({
	onChange,
	textInputStyle,
}: {
	onChange: (value: string) => void;
	textInputStyle?: {
		[key: string]: string;
	};
}) {
	const [typedCompanyName, setTypedCompanyName] = useState('');
	const { data: companiesData } = useQuery(['companies', typedCompanyName], () => searchCompanies(typedCompanyName), {
		staleTime: 60 * 1000,
	});
	const items = useMemo(() => {
		const items = [];
		const companies = companiesData?.companies?.map(c => ({ name: c, value: c })) || [];
		if (!companies.some(i => i.value === typedCompanyName) && typedCompanyName) {
			items.push({
				name: typedCompanyName,
				value: typedCompanyName,
			});
		}
		items.push(...companies);
		return items;
	}, [companiesData?.companies, typedCompanyName]);

	return (
		<div>
			<Downshift
				inputValue={typedCompanyName}
				onInputValueChange={value => setTypedCompanyName(value)}
				itemToString={item => (item ? item.name : '')}
				onChange={selection => onChange(selection.value)}
			>
				{({
					selectItem,
					getInputProps,
					getRootProps,
					getToggleButtonProps,
					getMenuProps,
					highlightedIndex,
					isOpen,
					selectedItem,
					getItemProps,
				}) => {
					const { onChange, onBlur, ...inputProps } = getInputProps({
						className: 'flex-grow',
						id: 'company',
					});
					return (
						<div className="relative">
							<div className="flex shadow-sm gap-0.5" {...getRootProps({}, { suppressRefError: true })}>
								<TextInput
									sizing="lg"
									type="text"
									required={true}
									onBlur={e => {
										selectItem({ name: typedCompanyName, value: typedCompanyName });
										onBlur && onBlur(e);
									}}
									onChange={e => {
										onChange && onChange(e);
									}}
									{...inputProps}
									style={textInputStyle}
									placeholder="Company name"
								/>
								{/* <button
                                    aria-label={'toggle menu'}
                                    className="px-2"
                                    type="button"
                                    {...getToggleButtonProps()}
                                >
                                    {isOpen ? <>&#8593;</> : <>&#8595;</>}
                                </button> */}
							</div>
							<ul
								className={`absolute w-full rounded-[8px] dark:bg-black bg-[#fff] mt-1 shadow-md max-h-80 overflow-scroll p-0 z-10 ${
									!(isOpen && items.length) && 'hidden'
								}`}
								{...getMenuProps()}
							>
								{items.map((item, index) => (
									<li
										className={cx(
											highlightedIndex === index && 'bg-blue-300',
											selectedItem === item && 'font-bold',
											'py-2 px-3 shadow-sm flex flex-col',
										)}
										{...getItemProps({
											key: item.value,
											index,
											item,
										})}
									>
										<span>{item.name}</span>
									</li>
								))}
							</ul>
						</div>
					);
				}}
			</Downshift>
		</div>
	);
}

export default CompanySelection;
